<template>
  <div class="swiper-container" v-if="floorData.data.length > 0">
    <van-swipe class="my-swipe" :show-indicators="false" :autoplay="3000">
      <van-swipe-item class="my-swipe-item" v-for="(item, index) in floorData.data" :key="index">
        <img v-if="item.imageUrl" v-lazy="item.imageUrl" @click="$jumpToPage(item)" />
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>

export default {
  name: 'Swiper',
  data: () => {
    return {
    }
  },
  props: ['floorData'],
  methods: {
    gotoUrl (item) {
      if (item.titleUrl) {
        location.href = item.titleUrl
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .swiper-container{
    .van-swipe{
      height: 1.88rem;
      .van-swipe-item {
        width: 3.75rem!important;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
</style>
